const WHATSAPP_URL =
  "https://wa.me/917487978020?text=" +
  encodeURIComponent("Hi, I'd like a consultation from Avvanta Advisory");

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat with Avvanta Advisory on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.55)] hover:scale-110 transition-transform duration-300"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="28"
        height="28"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.28c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15-.2.3-.78.97-.96 1.17-.18.2-.35.22-.65.08-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.79-1.68-2.1-.18-.3-.02-.47.13-.62.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.68-1.63-.92-2.23-.24-.58-.48-.5-.67-.5-.17 0-.37-.02-.57-.02-.2 0-.52.08-.8.37-.28.3-1.05 1.02-1.05 2.5 0 1.47 1.08 2.9 1.23 3.1.15.2 2.13 3.25 5.15 4.56.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.18-1.42-.07-.13-.28-.2-.58-.35zM16.02 5.33c-5.9 0-10.7 4.8-10.7 10.7 0 2.1.6 4.12 1.73 5.87L5.1 27.1l5.37-1.88a10.68 10.68 0 0 0 5.53 1.53h.01c5.9 0 10.7-4.8 10.7-10.7 0-2.87-1.12-5.56-3.14-7.58a10.62 10.62 0 0 0-7.57-3.14zm0 19.33h-.01a8.7 8.7 0 0 1-4.75-1.43l-.34-.21-3.2 1.12 1.08-3.18-.23-.35a8.66 8.66 0 0 1-1.36-4.68c0-4.8 3.9-8.7 8.72-8.7 2.32 0 4.5.9 6.15 2.55a8.6 8.6 0 0 1 2.55 6.15c0 4.8-3.9 8.73-8.71 8.73z" />
      </svg>
    </a>
  );
}
